<div class="chat-ui">
  <div #chatHistoryContainer class="chat-ui__chat-history">
    <ion-row *ngFor="let chat of chatUiModel().chats; let idx = index; trackBy: trackByChats" class="chat-ui__chat">
      <!-- Separator -->
      <ng-container *ngIf="chat.type === 'SEPARATOR'">
        <ion-row class="chat-ui__separator">
          <span class="chat-ui__separator__line"></span>
          <span class="chat-ui__separator__text">{{ chat.text }}</span>
          <span class="chat-ui__separator__line"></span>
        </ion-row>
      </ng-container>

      <!-- Query -->
      <ng-container *ngIf="chat.type === 'QUERY'">
        <ion-row class="chat-ui__query">
          <pre class="chat-ui__query__text">{{ chat.value }}</pre>
        </ion-row>
      </ng-container>

      <!-- Response -->
      <ng-container *ngIf="chat.type === 'RESPONSE'">
        <!-- Response: ERROR -->
        <ion-row *ngIf="chat.responseType === 'ERROR'" class="chat-ui__response--ERROR">
          <span class="chat-ui__response--ERROR__text">
            {{ chat.errorText | translate }}
          </span>
        </ion-row>

        <!-- Response: TEXT -->
        <ion-row *ngIf="chat.responseType === 'TEXT'" class="chat-ui__response--TEXT">
          <markdown
            class="chat-ui__response--TEXT__text"
            [data]="chat.displayText"
            [disableSanitizer]="false"
          ></markdown>
        </ion-row>

        <!-- Response: TABLE_AND_CHART -->
        <ion-row *ngIf="chat.responseType === 'TABLE_AND_CHART'" class="chat-ui__response--TABLE_AND_CHART">
          <div *ngIf="chat.data.answerExplanation" class="chat-ui__response--TABLE_AND_CHART__answer-explanation">
            <markdown [data]="chat.data.answerExplanation" [disableSanitizer]="false"></markdown>
          </div>

          <div *ngIf="chat.data.showViewBtns" class="chat-ui__response--TABLE_AND_CHART__view-btns">
            <markdown
              *ngIf="chat.data.dataSummaryMessage"
              class="chat-ui__response--TABLE_AND_CHART__summary"
              [data]="chat.data.dataSummaryMessage"
              [disableSanitizer]="false"
            ></markdown>
            <ui-custom-button
              *ngIf="chat.data.showViewBtns"
              [btnTxt]="'chat_ui_model.ViewTable' | translate"
              (clickEvent)="viewTable(chat.data.tableModel, chat.rawData)"
              iconSrc="assets/common/table-icon.svg"
            ></ui-custom-button>
            <ui-custom-button
              *ngIf="chat.data.highChartsConfig"
              [btnTxt]="'chat_ui_model.ViewGraph' | translate"
              (clickEvent)="viewChart(chat.data.highChartsConfig)"
              iconSrc="assets/common/chart-icon.svg"
            ></ui-custom-button>
          </div>

          <ng-container *ngIf="!chat.data.showViewBtns">
            <markdown
              *ngIf="chat.data.dataSummaryMessage"
              class="chat-ui__response--TABLE_AND_CHART__summary"
              [data]="chat.data.dataSummaryMessage"
              [disableSanitizer]="false"
            ></markdown>
            <ion-segment
              [value]="chat.data.tab"
              class="chat-ui__response--TABLE_AND_CHART__segment"
              *ngIf="chat.data.highChartsConfig"
            >
              <ion-segment-button (click)="onTabClick(chat.data, idx, 'TABLE')" value="TABLE">
                {{ 'chat_ui_model.Table' | translate }}
              </ion-segment-button>
              <ion-segment-button (click)="onTabClick(chat.data, idx, 'CHART')" value="CHART">
                {{ 'chat_ui_model.Graph' | translate }}
              </ion-segment-button>
            </ion-segment>

            <ui-table
              class="chat-ui__response--TABLE_AND_CHART__table"
              [zTableModel]="chat.data.tableModel"
              *ngIf="chat.data.tab === 'TABLE'"
            ></ui-table>
            <monorepo-ui-charts
              class="chat-ui__response--TABLE_AND_CHART__chart"
              *ngIf="chat.data.tab === 'CHART' && chat.data.highChartsConfig"
              [highChartsConfig]="chat.data.highChartsConfig"
            ></monorepo-ui-charts>
          </ng-container>

          <div
            *ngIf="chat.data.insightsInfo || chat.data.showDownloadBtn"
            class="chat-ui__response--TABLE_AND_CHART__insight-container"
          >
            <div>
              <ui-custom-button
                *ngIf="chat.data.showDownloadBtn"
                (clickEvent)="downloadTableData(chat.rawData)"
                iconSrc="assets/common/download-outline-white.svg"
              ></ui-custom-button>

              <ng-container *ngIf="chat.data.insightsInfo as info">
                <ui-custom-button
                  *ngIf="info.status !== 'GENERATED'"
                  [btnTxt]="
                    (info.status === 'GENERATING'
                      ? 'chat_ui_model.Generating'
                      : info.status === 'ERROR'
                      ? 'chat_ui_model.TryAgain'
                      : 'chat_ui_model.GenerateInsights'
                    ) | translate
                  "
                  (clickEvent)="generateInsights(chat.rawData, idx)"
                  [isDisabled]="info.status === 'GENERATING'"
                ></ui-custom-button>
              </ng-container>
            </div>

            <ng-container *ngIf="chat.data.insightsInfo as info">
              <div *ngIf="info.status === 'ERROR'" class="chat-ui__response--TABLE_AND_CHART__insight-err">
                {{ info.error | translate }}
              </div>
              <ng-container *ngIf="info.status === 'GENERATED'">
                <div *ngFor="let insight of info.insights" class="chat-ui__response--TABLE_AND_CHART__insights">
                  <markdown [data]="insight" [disableSanitizer]="false"></markdown>
                </div>
              </ng-container>
            </ng-container>
          </div>
        </ion-row>

        <!-- Feedback -->
        <ion-row *ngIf="chat.showFeedbackUi" class="chat-ui__feedback">
          <span>{{ 'chat_ui_model.FeedbackQuestion' | translate }}</span>
          <button
            class="chat-ui__feedback__btn"
            (click)="submitFeedback(chat.rawData, idx, 'POSITIVE')"
            *ngIf="chat.feedback !== 'POSITIVE'"
          >
            <ion-icon class="chat-ui__feedback__icon" name="thumbs-up-outline"></ion-icon>
          </button>
          <ion-icon class="chat-ui__feedback__icon" *ngIf="chat.feedback === 'POSITIVE'" name="thumbs-up"></ion-icon>

          <button
            class="chat-ui__feedback__btn"
            (click)="submitFeedback(chat.rawData, idx, 'NEGATIVE')"
            *ngIf="chat.feedback !== 'NEGATIVE'"
          >
            <ion-icon class="chat-ui__feedback__icon" name="thumbs-down-outline"></ion-icon>
          </button>
          <ion-icon class="chat-ui__feedback__icon" *ngIf="chat.feedback === 'NEGATIVE'" name="thumbs-down"></ion-icon>
        </ion-row>
      </ng-container>
    </ion-row>

    <!-- Welcome Message -->
    <ion-row class="chat-ui__welcome" *ngIf="nonSeparatorChatsCount() === 0 && initialUiText">
      <ion-row class="chat-ui__welcome--header">{{ initialUiText.header | translate }}</ion-row>
      <ion-row class="chat-ui__welcome--content" *ngIf="initialUiText.content">
        {{ initialUiText.content | translate }}
      </ion-row>
    </ion-row>

    <!-- Waiting Dots -->
    <ion-row *ngIf="chatUiModel().isWaiting" class="chat-ui__waiting">
      <div class="chat-ui__waiting__typing-indicator">
        <span *ngFor="let dot of [0, 1, 2]" class="chat-ui__waiting__dot"></span>
      </div>
    </ion-row>
  </div>

  <!-- Quick Questions -->
  <ng-container *ngIf="quickQuestions && quickQuestions.length > 0 && nonSeparatorChatsCount() === 0">
    <ion-row class="chat-ui__quick-questoions-container">
      <ion-item
        *ngFor="let quickQuestion of quickQuestions"
        class="chat-ui__quick-questoion"
        button
        lines="none"
        (click)="quickQuestionClicked(quickQuestion)"
      >
        {{ quickQuestion | translate }}
      </ion-item>
    </ion-row>
  </ng-container>

  <!-- Query Input -->
  <ion-row class="chat-ui__input">
    <ion-textarea
      autoGrow="true"
      rows="3"
      (ionChange)="onQueryChange($event)"
      [placeholder]="'chat_ui_model.PlaceholderText' | translate"
      class="chat-ui__input--textarea"
      [value]="chatUiModel().queryValue"
      autofocus="true"
      tabindex="0"
      #sendBtn
    ></ion-textarea>

    <ion-button [disabled]="chatUiModel().isSendBtnDisabled" (click)="onSendQuery()" class="chat-ui__input--send">
      <ion-icon name="send"></ion-icon>
    </ion-button>
  </ion-row>
</div>
